module.exports = __webpack_public_path__ + "media/images/default/pages/about/2-11d35acbe88c055c52db447e3b18970f.jpg";